import * as React from "react";

const Button = ({ disabled, loading, children }) => {
    return (
        <button
            className="relative inline-flex items-center font-heading justify-center whitespace-nowrap rounded text-base font-bold uppercase leading-[18px] border border-transparent transition-colors active:ring-4 disabled:opacity-25 disabled:cursor-not-allowed bg-brand-tertiary text-brand-white border-brand-tertiary hover:bg-brand-tertiary-darken active:bg-brand-tertiary-darken active:ring-brand-info py-[14px] px-[60px] text-lg leading-[24px]"
            disabled={disabled || loading}
        >
            <span>{children}</span>
        </button>
    );
};

Button.displayName = "Button";

export { Button };
